import { SelectOption } from '@fleet-beat/core';

export enum ViolationTypeEnum {
  BreakLimit = 'limit-break',
  CycleLimit = 'limit-cycle',
  DrivingLimit = 'limit-driving',
  ShiftLimit = 'limit-shift',
  NoDvir = 'no-dvir',
  NoCertification = 'no-certification',
  SSBBreakLimit = 'ssb-break-limit',
  SSBDrivingLimit = 'ssb-driving-limit',
  SSBShiftLimit = 'ssb-shift-limit',
}

export const ViolationTypeOptions: SelectOption[] = [
  { value: ViolationTypeEnum.BreakLimit, label: 'Break Limit' },
  { value: ViolationTypeEnum.CycleLimit, label: 'Cycle limit' },
  { value: ViolationTypeEnum.DrivingLimit, label: 'Driving limit' },
  { value: ViolationTypeEnum.ShiftLimit, label: 'Shift limit' },
  { value: ViolationTypeEnum.NoDvir, label: 'No PTI' },
  { value: ViolationTypeEnum.NoCertification, label: 'No Signature' },
  { value: ViolationTypeEnum.SSBBreakLimit, label: 'SSB Break Limit' },
  { value: ViolationTypeEnum.SSBDrivingLimit, label: 'SSB Driving Limit' },
  { value: ViolationTypeEnum.SSBShiftLimit, label: 'SSB Shift Limit' },
];
